export default Object.freeze({
  EXCEL: 0,
  WORD: 1,
  DETAIL_WORD: 2,
  PROPERTY_BROCHURE: 3,
  BOOKLET_EXCEL: 5,
  BOOKLET_PDF: 6,
});
